import { toast } from "react-toastify";

export const handleError = (message) => {
  console.log(message);
  toast.error(message);
};

export default handleError;
